export function getSortParamsFromString (sortString) {
  if(!sortString) {
    return {}
  }
  let charToSplit = '';
  let order = ''
  if(sortString.startsWith('-')) {
    charToSplit = '-';
    order = 'descending';
  } else if(sortString.startsWith('+')) {
    charToSplit = '+';
    order = 'ascending';
  }
  if(!charToSplit){
    return {};
  }
  let prop = sortString.substring(1);
  return {
    order,
    prop
  }
}

export function getSortParamsFromArray(filters = []) {
  let sort = filters.find(f => f.key === 'sort');
  if(!sort) {
    return {}
  }
  let sortValue = sort.value;
  return getSortParamsFromString(sortValue);
}
